import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, role }) {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-surface)' }}>
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-transparent" style={{ borderTopColor: '#F5D547' }} />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role && user?.role !== role && user?.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-surface)' }}>
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2" style={{ color: '#EF4444' }}>
            Accès non autorisé
          </h1>
          <p style={{ color: 'var(--text-secondary)' }}>
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>
          <Link
            to="/"
            className="mt-4 inline-block px-4 py-2 rounded-lg text-sm font-medium"
            style={{ backgroundColor: '#F5D547', color: '#050505' }}
          >
            Retour à l'accueil
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
